/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductScalePrice } from './ProductScalePrice';
import {
    ProductScalePriceFromJSON,
    ProductScalePriceFromJSONTyped,
    ProductScalePriceToJSON,
    ProductScalePriceToJSONTyped,
} from './ProductScalePrice';

/**
 * 
 * @export
 * @interface ProductPrices
 */
export interface ProductPrices {
    /**
     * 
     * @type {string}
     * @memberof ProductPrices
     */
    articleNumber: string;
    /**
     * 
     * @type {number}
     * @memberof ProductPrices
     */
    basePrice: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPrices
     */
    discount: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPrices
     */
    discountedPrice: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPrices
     */
    suggestedRetailPrice: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPrices
     */
    freightSurcharge: number;
    /**
     * 
     * @type {Array<ProductScalePrice>}
     * @memberof ProductPrices
     */
    scalePrices: Array<ProductScalePrice>;
}

/**
 * Check if a given object implements the ProductPrices interface.
 */
export function instanceOfProductPrices(value: object): value is ProductPrices {
    if (!('articleNumber' in value) || value['articleNumber'] === undefined) return false;
    if (!('basePrice' in value) || value['basePrice'] === undefined) return false;
    if (!('discount' in value) || value['discount'] === undefined) return false;
    if (!('discountedPrice' in value) || value['discountedPrice'] === undefined) return false;
    if (!('suggestedRetailPrice' in value) || value['suggestedRetailPrice'] === undefined) return false;
    if (!('freightSurcharge' in value) || value['freightSurcharge'] === undefined) return false;
    if (!('scalePrices' in value) || value['scalePrices'] === undefined) return false;
    return true;
}

export function ProductPricesFromJSON(json: any): ProductPrices {
    return ProductPricesFromJSONTyped(json, false);
}

export function ProductPricesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductPrices {
    if (json == null) {
        return json;
    }
    return {
        
        'articleNumber': json['articleNumber'],
        'basePrice': json['basePrice'],
        'discount': json['discount'],
        'discountedPrice': json['discountedPrice'],
        'suggestedRetailPrice': json['suggestedRetailPrice'],
        'freightSurcharge': json['freightSurcharge'],
        'scalePrices': ((json['scalePrices'] as Array<any>).map(ProductScalePriceFromJSON)),
    };
}

export function ProductPricesToJSON(json: any): ProductPrices {
    return ProductPricesToJSONTyped(json, false);
}

export function ProductPricesToJSONTyped(value?: ProductPrices | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'articleNumber': value['articleNumber'],
        'basePrice': value['basePrice'],
        'discount': value['discount'],
        'discountedPrice': value['discountedPrice'],
        'suggestedRetailPrice': value['suggestedRetailPrice'],
        'freightSurcharge': value['freightSurcharge'],
        'scalePrices': ((value['scalePrices'] as Array<any>).map(ProductScalePriceToJSON)),
    };
}

